export const WHATS_NEW_SEEN_KEY = "whatsNew.lastSeen";

export const readWhatsNewSeen = (): string | null => {
  try {
    return window.localStorage.getItem(WHATS_NEW_SEEN_KEY);
  } catch {
    return null;
  }
}

export const writeWhatsNewSeen = (id: string) => {
  try {
    window.localStorage.setItem(WHATS_NEW_SEEN_KEY, id);
  } catch {
    // storage unavailable
  }
}

export const hasUnseenWhatsNew = (latestId: string | undefined): boolean =>
  !!latestId && readWhatsNewSeen() !== latestId;
